/** @jsxImportSource @emotion/react */
import React, { ReactNode, useState } from "react";
import { Header } from "../Header/Header";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Theme } from "styles/theme";
import styled from "@emotion/styled";
import { SideNav } from "components/NavbarV2/elements/SideNav";
import Footer from "./elements/Footer";
import { useIsMobile } from "hooks/useDeviceType";

interface LayoutProps {
  children?: ReactNode;
  isNotFound?: boolean;
}

export const HomeLayout: React.FC<LayoutProps> = props => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  return (
    <LayoutContainer theme={theme}>
      <Header setIsSideNavOpen={setIsSideNavOpen} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? 120 : 200,
          alignItems: "center",
        }}
      >
        {props.children}
      </div>

      <SideNav isOpen={isSideNavOpen} setIsOpen={setIsSideNavOpen} />
      <Footer />
    </LayoutContainer>
  );
};

// Sub-components

interface LayoutContainerProps {
  theme: Theme;
}

export const LayoutContainer = styled.div<LayoutContainerProps>`
  position: relative;
`;
